import { Box, Typography, Link, styled } from '@mui/material';

import { useRegistration } from '../../contexts/RegistrationContext.js';
import { useSignInNavigation } from '../../hooks/use-sign-in-navigation.js';

const SignInLink = styled(Link)({
  textDecoration: 'none',
  fontSize: 16,
  cursor: 'pointer',
  marginLeft: 4,

  '&:hover': {
    textDecoration: 'none',
  },
});

const SuccessTitle = styled(Typography)({
  fontSize: 20,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontFamily: 'Red Hat Display, sans-serif',
  fontWeight: 700,
  color: '#000',
  textAlign: 'center',
});

const Success = () => {
  const { userCreated } = useRegistration();
  const { navigateToSignIn } = useSignInNavigation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <SuccessTitle>Registration Complete</SuccessTitle>
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        You have successfully completed your registration.{' '}
        {userCreated
          ? 'Your account creation has been confirmed.'
          : 'Your account requires confirmation. You will receive an email as soon as we process the request'}
        {userCreated && <SignInLink onClick={navigateToSignIn}>You can now Log In</SignInLink>}
      </Typography>
    </Box>
  );
};

export default Success;
